export default "__VITE_ASSET__AioR8c9m__"